module.exports = __webpack_public_path__ + "img/specialty_whale.232f042.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/specialty_whale.png
// module id = nnbL
// module chunks = 15